define("shared/services/shared/popup-manager", ["exports", "@ember/service", "later/services/errors", "shared/lib/popup-instance"], function (_exports, _service, _errors, _popupInstance) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "PopupInstance", {
    enumerable: true,
    get: function () {
      return _popupInstance.PopupInstance;
    }
  });
  _exports.default = _exports.PopupManagerService = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"later/services/errors",0,"shared/lib/popup-instance"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let PopupManagerService = (_class = class PopupManagerService extends _service.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "errors", _descriptor, this);

      _defineProperty(this, "popups", {});
    }

    createPopup(name, config) {
      this.closeAllPopups();
      const createdPopup = new _popupInstance.PopupInstance({
        name,
        config: { ...config,
          _manager: {
            onError: (error, severity) => this.onError(error, severity),
            onOpened: () => this.onOpenedPopup(name),
            onClosed: error => this.onClosedPopup(name, error),
            onMessageReceived: message => this.onMessageReceivedPopup(name, message),
            onMessageSent: message => this.onMessageSentPopup(name, message)
          }
        }
      });
      this.popups[name] = createdPopup;
      return createdPopup;
    }

    findPopup(name) {
      const found = this.popups[name];

      if (!found) {
        return undefined;
      }

      return found;
    }

    listPopups() {
      return Object.values(this.popups).filter(Boolean);
    }

    closePopup(name) {
      const popup = this.findPopup(name);

      if (!popup) {
        console.warn(`Popup window "${name}" doesn't exist or has already been closed.`);
        return;
      }

      popup.close();
    }

    closeAllPopups() {
      this.listPopups().forEach(popupInstance => this.closePopup(popupInstance.name));
    }

    onClosedPopup(name, error) {
      const popup = this.findPopup(name);

      if (!popup) {
        return;
      }

      this.errors.log(error ? `Popup closed with name "${name}" and encountered an error: ${error}` : `Popup closed with name "${name}"`, undefined, _errors.ErrorSeverity.Debug);
      delete this.popups[name];
    }

    onOpenedPopup(name) {
      this.errors.log(`Popup opened with name "${name}"`, undefined, _errors.ErrorSeverity.Debug);
    }

    onMessageReceivedPopup(name, message) {
      this.errors.log(`Popup with name "${name}" received a message: ${JSON.stringify(message.data)}`, undefined, _errors.ErrorSeverity.Debug);
    }

    onMessageSentPopup(name, message) {
      this.errors.log(`Popup with name "${name}" sent a message: ${JSON.stringify(message.data)}`, undefined, _errors.ErrorSeverity.Debug);
    }

    onError(error, severity) {
      this.errors.log(error, undefined, severity);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.PopupManagerService = PopupManagerService;
  var _default = PopupManagerService;
  _exports.default = _default;
});